export enum GuidedTourEventName {
  tourComplete = "tour-complete",
}
